import {promisifyModal} from 'common/components/modal/utils';

import {CustomPropertyBuilderParams, CustomPropertyBuilderResult} from './types';
import {customPropHasGroupProperty} from './util';
// eslint-disable-next-line import/no-cycle
import {CustomPropertyBuilderEl} from './index';

export async function promptCustomProperties(params: CustomPropertyBuilderParams): Promise<{
  appliedValue?: CustomPropertyBuilderResult[`appliedValue`];
  didClose: boolean;
  deletedId: string | number | null;
  hasGroupProperty: boolean;
}> {
  const closeEv = await promisifyModal<CustomEvent<CustomPropertyBuilderResult>>({
    panelElement: CustomPropertyBuilderEl,
    attrs: {},
    params,
    closeEvents: [`apply`, `cancel`, `change`, `delete`],
  });
  const customProp = closeEv.detail?.appliedValue?.customProperty;

  return {
    appliedValue: closeEv.detail?.appliedValue,
    didClose: closeEv.type === `cancel`, // there is no event type 'change' || (closeEv.type === `change` && closeEv.detail.state === Visibility.Closed),
    deletedId: closeEv.type === `delete` ? closeEv.detail.customPropertyId! : null,
    hasGroupProperty: customProp ? customPropHasGroupProperty(customProp) : false,
  };
}
